import * as React from 'react'
import { FC } from 'react'

import { Chevron } from '@sales-center/components'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

const styles = {
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    flexFlow: 'row no-wrap',
    fontSize: '14px',
    lineHeight: '40px',
    cursor: 'pointer',
    transition: 'all 0.25s',
    '&:hover': {
      backgroundColor: '#f7f7f7',
    },
  },

  drawerLabel: { transition: 'all 0.25s ease-in-out' },
  drawerOpen: { opacity: 0 },

  footerClosed: {
    borderTop: '1px solid #dddddd',
  },

  footerOpen: {
    boxShadow: '1px 4px 4px 0px #dddddd',
  },
}

interface Props {
  handleOpenDrawer: () => void
  isOpen: boolean
  title: string
}

export const SalesFunnelCardFooter: FC<Props> = (props) => {
  const { handleOpenDrawer, isOpen, title } = props

  return (
    <Box
      sx={[styles.root, isOpen ? styles.footerOpen : styles.footerClosed]}
      px={2}
      onClick={handleOpenDrawer}
      data-test-id="funnelStageDetailsBtn"
    >
      <Box display="flex" alignItems="center">
        <Typography>{title}</Typography>
      </Box>
      <Chevron open={isOpen} dataTestId="funnelStageDetailsChevron" />
    </Box>
  )
}

SalesFunnelCardFooter.displayName = 'SalesFunnelCardFooter'
